export default __webpack_public_path__ + "static/media/applewatch6-bg-dark.8182344e.webp";